import { useState } from "react";
import { login } from "../api/client";

interface Props {
  onLogin: (session: { username: string; rememberme: string }, remember: boolean) => void;
}

export default function Login({ onLogin }: Props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await login(username.trim(), password);
      onLogin({ username: res.username || username.trim(), rememberme: res.rememberme }, true);
    } catch (err: any) {
      setError(err?.response?.data?.error || err?.message || "Error de inicio de sesión");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-shell">
      <img className="login-logo" src="/logo_tspoonlab_light.png" alt="TSpoonLab" />
      <form className="login-form" onSubmit={submit}>
        <input
          className="login-input"
          type="text"
          placeholder="Usuario"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          autoFocus
        />
        <input
          className="login-input"
          type="password"
          placeholder="Contraseña"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button className="login-btn" type="submit" disabled={loading || !username || !password}>
          {loading ? "Conectando…" : "Entrar"}
        </button>
        {error && <p className="login-error">{error}</p>}
      </form>
    </div>
  );
}
